module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-16.60d6c9f9.png";